import {DateTime} from 'luxon';
import {CLEnum} from 'common/src/modules/enums/enums.types';

export interface ReferencedObjects {
  feedId?: number;
  locationFeedId?: number;
  contentFeedId?: number;
  relatedItemLogicId?: number;
  creativeId?: number;
  datasourceId?: number;
  clientIntegrationId?: number;
  limitOrQuotaName?: string;
  links: ReferencedObjectsLink[];
  uniquenessId?: number;
}

interface ReferencedObjectsLink {
  url: string;
  title: string;
}

interface RemoteNotification {
  campaignId: number;
  clientId: number;
  category: number;
  count: number;
  description: string;
  details: string;
  firstSeen: string;
  id: number;
  lastSeen: string;
  referencedObjects?: ReferencedObjects;
  reportUrl: string;
  severity: number;
  state: number;
  title: string;
  type: string;
  ownerFullName: string;
  closedAt?: string;
  comment?: string;
}

interface Notification
  extends Omit<
    RemoteNotification,
    'state' | 'severity' | 'category' | 'firstSeen' | 'lastSeen' | 'closedAt'
  > {
  firstSeen: DateTime;
  lastSeen: DateTime;
  severity: CLEnum;
  status: CLEnum;
  category: CLEnum;
  closedAt?: DateTime;
}

interface NotificationList {
  title: string;
  items: Notification[];
}

enum NotificationType { // NotificationType
  Severity = 'severity',
  Category = 'category',
  Status = 'status',
  Campaign = 'campaign',
  NumberOfOccurrences = 'occurrence',
  Date = 'date',
}

enum NotificationStatus {
  Open = 10,
  Dismissed = 20,
  Resolved = 30,
  Expired = 40,
}

enum NotificationSeverityName {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

enum NotificationSeverity {
  Info = 10,
  Warning = 20,
  Error = 30,
}

enum NotificationCategory {
  CampaignSetUp = 10,
  Feeds = 20,
  ScheduledReports = 30,
  CampaignAdServing = 40,
  CampaignInsights = 50,
  Job = 60,
}

interface RemoteTrendGraphData {
  dateTime: string;
  count: number;
}

interface TrendGraphData extends Omit<RemoteTrendGraphData, 'dateTime'> {
  dateTime: DateTime;
}

export enum NotificationFilterKey {
  Filters = 'filters',
  Sort = 'sort',
  Dates = 'dates',
  QuickSearch = 'search',
  DatePickingType = 'dateType',
}

export {
  Notification,
  NotificationList,
  RemoteNotification,
  NotificationType,
  NotificationStatus,
  NotificationSeverity,
  NotificationCategory,
  NotificationSeverityName,
  TrendGraphData,
  RemoteTrendGraphData,
};
